// extracted by mini-css-extract-plugin
module.exports = {"header":"GlobalHeader_header_10wGx","label":"GlobalHeader_label_7aKXw","update":"GlobalHeader_update_3sCWZ"};